export default __webpack_public_path__ + "static/media/infoIcon.1cac8f7c.svg";